import React, { useState } from 'react';
import './App.css';



  const outputStyle = {
   'text-align': 'right',
   width: '60%',
  };

function Royalty() {
    const [bookPrice, setBookPrice] = useState('5.99');
    const [numCopiesSold, setNumCopiesSold] = useState('25000');
    const [advanceAmount, setAdvanceAmount] = useState('5000');
    const [hasLiteraryAgent, setHasLiteraryAgent] = useState(true);
    const [royaltyRate, setRoyaltyRate] = useState(8); // Default royalty rate: 10 (10%)
    const agentCommissionRate = 0.15; // 15% literary agent commission rate
  
    const handleBookPriceChange = (event) => {
      const input = event.target.value.replace(/[^0-9.]/g, ''); // Allow only numeric and decimal input
      setBookPrice(input);
    };
  
    const handleNumCopiesSoldChange = (event) => {
      const input = event.target.value.replace(/[^0-9]/g, ''); // Allow only numeric input
      setNumCopiesSold(input);
    };
  
    const handleAdvanceAmountChange = (event) => {
      const input = event.target.value.replace(/[^0-9.]/g, ''); // Allow only numeric and decimal input
      setAdvanceAmount(input);
    };
  
    const handleAgentCheckboxChange = (event) => {
      setHasLiteraryAgent(event.target.checked);
    };
  
    const handleRoyaltyRateChange = (event) => {
      const input = event.target.value.replace(/[^0-9]/g, ''); // Allow only numeric input
      setRoyaltyRate(parseInt(input, 10));
    };
  
    const calculateRoyalty = () => {
        const totalPrice = parseFloat(bookPrice) * parseFloat(numCopiesSold);
        let royalty = totalPrice - parseFloat(advanceAmount);
      
        if (hasLiteraryAgent) {
          royalty -= totalPrice * agentCommissionRate;
        }
      
        const totalRoyalty = royalty > 0 ? (royalty * royaltyRate) / 100 : 0;
        //const agentCommission = hasLiteraryAgent ? totalPrice * agentCommissionRate : 0;

/* 
            $amountEarnedPerBooks = $bookType * ($royaltyPercentage/100); NOW amountPerBook
        	$earnedFromBooksSold = $amountEarnedPerBooks * $booksSold;
        	$totalPotIncome = $earnedFromBooksSold - $advancedAmount;
			$agentCommissionFinal  = $totalPotIncome * $agentCommissionPercent;
        	$potProfitAfterCommission = $totalPotIncome - $agentCommissionFinal;*/

       /*  const amountPerBook =
          parseFloat(numCopiesSold) > 0 ? totalRoyalty / parseFloat(numCopiesSold) : 0; */

          const amountPerBook = parseFloat(bookPrice) > 0 ? parseFloat(bookPrice) * (royaltyRate/100) : 0;
          const earnedFromBooksSold = amountPerBook * numCopiesSold;
          const totalPotIncome  = earnedFromBooksSold - advanceAmount;
          const agentCommission = hasLiteraryAgent ? totalPotIncome * agentCommissionRate : 0;
          const potProfitAfterCommission = totalPotIncome - agentCommission;
      
        return { totalRoyalty, agentCommission, amountPerBook, totalPotIncome, potProfitAfterCommission };
      };
      
  
    const { totalRoyalty, agentCommission, amountPerBook, totalPotIncome,potProfitAfterCommission } = calculateRoyalty();
  
    return (
      <div className=" ">
        <div className="input-container">
          <label>Advance Amount ($):</label>
          <input
            type="text"
            className="form-control input-md"
            value={advanceAmount}
            onChange={handleAdvanceAmountChange}
            placeholder="Enter advance amount"
          />
        </div>
        <div className="input-container">
          <label>Book Price ($):</label>
          <input
            type="text"
            className="form-control input-md"
            value={bookPrice}
            onChange={handleBookPriceChange}
            placeholder="Enter book price"
          />
        </div>
        <div className="input-container">
          <label>Copies Sold:</label>
          <input
            type="text"
            className="form-control input-md"
            value={numCopiesSold}
            onChange={handleNumCopiesSoldChange}
            placeholder="Enter number of copies sold"
          />
        </div>
       
        <div className="input-container">
          <label>
            <input
              type="checkbox"
              checked={hasLiteraryAgent}
              onChange={handleAgentCheckboxChange}
            />
            &nbsp;Literary Agent (Deduct 15%)
          </label>
        </div>
        <div className="input-container">
          <label>Royalty Rate (%):</label>
          <input
            type="text"
            className="form-control input-md"
            value={royaltyRate}
            onChange={handleRoyaltyRateChange}
            placeholder="Enter royalty rate"
          />
        </div>
<div><h4>Will You Earn Out Your Advance?</h4></div>
        <table class="table table-primary table-hover">
    <tr>
      <td style={{outputStyle}}>Amount Earned Per Book:</td>
      <td><b>${amountPerBook.toFixed(2)}</b></td>
    </tr>
 <tr>
 <td style={{outputStyle}}>Agent Commission:</td>
      <td>{hasLiteraryAgent && <span> ${agentCommission.toFixed(2)}</span>}</td>
    </tr>
 <tr>
 <td style={{outputStyle}}>Potential Profit After Commission:</td>
      <td>${potProfitAfterCommission.toFixed(2)}</td>
    </tr>
 <tr>
 <td style={{outputStyle}}>Total Potential Income Earned:</td>
      <td>${totalPotIncome.toFixed(2)}</td>
    </tr>
<tr>
<td style={{outputStyle}}>Total Royalty Earned:</td>
      <td><b>${totalRoyalty.toFixed(2)}</b></td>
    </tr>
</table>


      </div>
    );
}
//  
export default Royalty;
